import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog"

interface PaymentMethodRequiredDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function PaymentMethodRequiredDialog({
  open,
  onOpenChange,
}: PaymentMethodRequiredDialogProps) {
  const navigate = useNavigate()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogTitle className="sr-only">カード情報登録のお願い</DialogTitle>
        <DialogDescription className="text-base text-slate-700 text-pretty py-4">
          お支払いに必要なクレジットカード情報が登録されていません。
          マイページからカード情報登録を行ってください。
        </DialogDescription>
        <DialogFooter className="justify-center">
          <Button onClick={() => navigate("/profile")}>マイページへ</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
